exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toggle-active-button[data-v-5f575d12] {\n  padding: 5px 10px;\n  height: auto !important;\n}\n\n", ""]);

// exports
